import { ColumnSort } from '@tanstack/react-table';
import { toString } from 'lodash';
import { stringify } from 'qs';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'hotel/navigation';

const useQueryUrl = <T>(sorting?: ColumnSort, filters?: T) => {
  const location = useLocation();
  const navigate = useNavigate();

  const filterQueryUrl = useMemo(() => {
    const q = new URLSearchParams(location.search);

    if (sorting) {
      q.set(`sorting_id`, sorting.id);
      q.set(`sorting_desc`, toString(sorting.desc));
    } else {
      q.delete(`sorting_id`);
      q.delete(`sorting_desc`);
    }

    if (filters) {
      q.set('filters', stringify(filters));
    } else {
      q.delete('filters');
    }

    // sort the query string
    q.sort();

    const queryString = q.toString();

    return location.pathname + (queryString ? `?${queryString}` : '');
  }, [location.pathname, location.search, sorting, filters]);

  useEffect(() => {
    if (`${location.pathname}${location.search}` !== filterQueryUrl) {
      navigate(filterQueryUrl, { replace: true });
    }
  }, [filterQueryUrl, location.pathname, location.search, navigate]);

  return filterQueryUrl;
};

export default useQueryUrl;
